function convert_object_to_flat_ini(ini_output, section_object, hashMode = false) {
    for (var key in section_object) {
        var value = section_object[key];

        if (typeof value === "object") ini_output = convert_object_to_flat_ini(ini_output, value, hashMode);
        else if (hashMode && key.includes("Col")) ini_output += key + "=\n";
        else {
            if (value && value.replace) value = value.replace(/(?:\r\n|\r|\n)/g, "<br>");

            ini_output += key + "=" + value + "\n";
        }

        if (key === "BeamCol1") ini_output += "BeamCol" + "=" + value + "\n";
        if (key === "BeamList1") ini_output += "BeamList" + "=" + value + "\n";
        if (key === "BeamName1") ini_output += "BeamName" + "=" + value + "\n";
        if (key === "BeamType1") ini_output += "BeamType" + "=" + value + "\n";
        if (key === "RoofSheetColour") ini_output += "RoofColour" + "=" + value + "\n";
        if (key === "AttachmentType") ini_output += "FasciaType" + "=" + value + "\n";
        if (key === "RoofPitch") ini_output += "Pitch" + "=" + value + "\n";
    }
    return ini_output;
}

function write_section_name_for_qq_nn(section_name, nn) {
    if (nn > 0) {
        return "[_" + nn + "_" + section_name + "]\n";
    } else {
        return "[" + section_name + "]\n";
    }
}

// Added user at the end for SmartkitsAPI - V8 Engine
export function convertJobStateToIni(
    in_job_state,
    app = null,
    mode = "",
    config = null,
    user,
    brand = null,
    V8 = false
) {
    // If running from V8 need to parse stringified objects
    if (V8) {
        in_job_state = JSON.parse(in_job_state);
        user = JSON.parse(user);
    }
    let job_state = QQadjustments(in_job_state, config, brand);
    let hashMode = false;
    if (mode === "hash") hashMode = true;
    let ini_output = "";
    ini_output += "[CUSTOMER]\n";
    if (job_state.Customer && !hashMode) {
        let customer = {
            ...job_state.Customer,
            AlternateName: job_state.Customer.JobName,
        };
        ini_output = convert_object_to_flat_ini(ini_output, customer, hashMode);
    }
    ini_output += "[QUOTE]\n";
    ini_output += "ID=" + job_state.id + "\n";
    ini_output += "DesignSummary=" + job_state.DesignSummary + "\n";
    ini_output += "OrderTimestamp=" + (job_state.OrderTimestamp || "") + "\n";
    ini_output += "OrderBy=" + (job_state.OrderBy || "") + "\n";
    ini_output += "OrderBy=" + (job_state.OrderBy || "") + "\n";
    ini_output += "ERPNumbers=" + (JSON.stringify(job_state.ErpNumbers || "") || "") + "\n";

    ini_output += "[CURRENT_USER]\n";
    if (!hashMode) {
        let user_only = {
            ...(app?.user ?? user),
            BusinessDetails: null,
            LastQuotesEdited: null,
        };
        ini_output = convert_object_to_flat_ini(ini_output, user_only, hashMode);
    }

    ini_output += "[CURRENT_DEALER]\n";
    if (!hashMode) {
        // No need to include FixedPriceKits in flat ini
        let distributor = job_state?.Distributor;
        delete distributor?.FixedPriceKits;

        let business = {
            ...job_state.Distributor,
            BusinessName: job_state.Distributor?.Name,
        };

        ini_output = convert_object_to_flat_ini(ini_output, business, hashMode);
    }

    ini_output += "[JOB_DATA]\n";
    if (job_state.QuoteParameters) {
        let quoteParamters = {
            ...job_state.QuoteParameters,
            POA: job_state?.App?.temp_POA
                ? job_state?.App?.temp_POA
                : job_state.POA
                ? job_state.POA
                : job_state.Distributor?.POA,
            engineeringHashCodeData: null,
            currentHashCodeData: null,
            ENGINEERING: null,
            BOM: null,
            DOCUMENTS: null,
            PRICING_PARAMETERS: null,
        };

        ini_output = convert_object_to_flat_ini(ini_output, quoteParamters, hashMode);
    }
    if (job_state.SiteParameters) {
        const { NonStandardDeliveryArea, WindData, ...rest } = job_state.SiteParameters;

        ini_output = convert_object_to_flat_ini(
            ini_output,
            {
                ...rest,
                WindZone: WindData?.WindZone,
                Blocking: job_state?.SiteParameters?.WindData?.Blocking,
                ExistingStructure: {
                    ...rest.ExistingStructure,
                    FloorType: "Concrete",
                    FloorColour: "999999,60",
                },
            },
            hashMode
        );
    }
    if (job_state.DesignParameters) {
        ini_output = convert_object_to_flat_ini(ini_output, job_state.DesignParameters, hashMode);
    }
    if (job_state.AcceptedErrorOverrides) {
        ini_output += "AcceptedErrorOverrides=" + JSON.stringify(job_state.AcceptedErrorOverrides) + "\n";
    }

    Object.size = function (obj) {
        var size = 0,
            key;
        for (key in obj) {
            if (obj?.hasOwnProperty(key)) size++;
        }
        return size;
    };

    if (job_state.AreaSpecifications) {
        ini_output += "[Areas]\n";
        ini_output += "NumAreas=" + Object.size(job_state.AreaSpecifications) + "\n";
        ini_output += "NumExtraAreas=0\n";
        for (var key in job_state.AreaSpecifications) {
            ini_output += write_section_name_for_qq_nn("BASIC_SPECS", key);
            ini_output += "AreaIndex=" + key + "\n";

            let area_data = {
                EXISTING_STRUCTURE: {
                    ...job_state.AreaSpecifications[key].EXISTING_STRUCTURE,
                },
                SHAPE: {
                    ...job_state.AreaSpecifications[key].SHAPE,
                    CUTOUTS: null,
                },
                ATTACHMENTS: {
                    ...job_state.AreaSpecifications[key].ATTACHMENTS,
                    PARTIAL_ATTACHMENTS: null,
                    AttachmentModifications: null,
                },
                BEAMS_AND_POSTS: {
                    ...job_state.AreaSpecifications[key].BEAMS_AND_POSTS,
                },
                ROOF_SHEETING: {
                    ...job_state.AreaSpecifications[key].ROOF_SHEETING,
                },
                GUTTERS_AND_DOWNPIPES: {
                    ...job_state.AreaSpecifications[key].GUTTERS_AND_DOWNPIPES,
                    Downpipes: null,
                },
                DECK_PARAMETERS: {
                    ...job_state.AreaSpecifications[key].DECK_PARAMETERS,
                    DeckBracing: JSON.stringify(job_state.AreaSpecifications[key].DECK_PARAMETERS.DeckBracing),
                    DeckPosts: JSON.stringify(job_state.AreaSpecifications[key].DECK_PARAMETERS.DeckPosts),
                },
                GABLE_PARAMETERS: {
                    ...job_state.AreaSpecifications[key].GABLE_PARAMETERS,
                },
                ENGINEERING_AND_DESIGN: {
                    ...job_state.AreaSpecifications[key].ENGINEERING_AND_DESIGN,
                },
                OPTIONS: {
                    ...job_state.AreaSpecifications[key].OPTIONS,
                },
                META: {
                    RoofArea: job_state.AreaSpecifications[key]?.META?.RoofArea,
                },
            };

            if (mode === "3D") {
                // allows infills to always be generated for 3d
                if (area_data.GABLE_PARAMETERS.TrussInfill1 === "None")
                    area_data.GABLE_PARAMETERS.TrussInfill1 = "Plain Smooth";
                if (area_data.GABLE_PARAMETERS.TrussInfill2 === "None")
                    area_data.GABLE_PARAMETERS.TrussInfill2 = "Plain Smooth";
            }
            if (area_data.GABLE_PARAMETERS.TrussInfill1 === "No Beams")
                area_data.GABLE_PARAMETERS.TrussInfill1 = "None";
            if (area_data.GABLE_PARAMETERS.TrussInfill2 === "No Beams")
                area_data.GABLE_PARAMETERS.TrussInfill2 = "None";

            if (
                job_state.AreaSpecifications?.[key]?.Downlights &&
                Object.keys(job_state.AreaSpecifications[key]?.Downlights).length > 0
            ) {
                area_data.Downlights = JSON.stringify(job_state.AreaSpecifications[key]?.Downlights);
            }
            if (
                job_state.AreaSpecifications?.[key]?.Fans &&
                Object.keys(job_state.AreaSpecifications[key]?.Fans).length > 0
            ) {
                area_data.Fans = JSON.stringify(job_state.AreaSpecifications[key]?.Fans);
            }
            if (
                job_state.AreaSpecifications?.[key]?.DeleteBeams &&
                Object.keys(job_state.AreaSpecifications[key]?.DeleteBeams).length > 0
            ) {
                area_data.DeleteBeams = JSON.stringify(job_state.AreaSpecifications[key]?.DeleteBeams);
            }
            if (
                job_state.AreaSpecifications?.[key]?.DeletePosts &&
                Object.keys(job_state.AreaSpecifications[key]?.DeletePosts).length > 0
            ) {
                area_data.DeletePosts = JSON.stringify(job_state.AreaSpecifications[key]?.DeletePosts);
            }
            if (
                job_state.AreaSpecifications?.[key]?.PostPositionAdjustments &&
                Object.keys(job_state.AreaSpecifications[key]?.PostPositionAdjustments).length > 0
            ) {
                area_data.PostPositionAdjustments = JSON.stringify(
                    job_state.AreaSpecifications[key]?.PostPositionAdjustments
                );
            }

            if (
                job_state.AreaSpecifications?.[key]?.SpliceAdjustments &&
                Object.keys(job_state.AreaSpecifications[key]?.SpliceAdjustments).length > 0
            ) {
                area_data.SpliceAdjustments = JSON.stringify(job_state.AreaSpecifications[key]?.SpliceAdjustments);
            }

            ini_output = convert_object_to_flat_ini(ini_output, area_data, hashMode);

            if (job_state?.QuoteParameters?.AREA_DATA?.[key]) {
                ini_output = convert_object_to_flat_ini(
                    ini_output,
                    job_state?.QuoteParameters?.AREA_DATA?.[key],
                    hashMode
                );
            }

            //always output downpipes
            ini_output += write_section_name_for_qq_nn("Downpipes", key);
            ini_output +=
                "AddAutomaticDownpipes=" +
                job_state.AreaSpecifications[key].GUTTERS_AND_DOWNPIPES.AddAutomaticDownpipes +
                "\n";
            if (job_state.AreaSpecifications[key].GUTTERS_AND_DOWNPIPES.Downpipes) {
                ini_output += ConvertArrayToIniSection(
                    "Downpipes",
                    key,
                    job_state.AreaSpecifications[key].GUTTERS_AND_DOWNPIPES.Downpipes,
                    ""
                );
            }
            if (
                job_state.AreaSpecifications[key].ATTACHMENTS.PARTIAL_ATTACHMENTS &&
                job_state.AreaSpecifications[key].ATTACHMENTS.PARTIAL_ATTACHMENTS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "PartialAttachments",
                    key,
                    job_state.AreaSpecifications[key].ATTACHMENTS.PARTIAL_ATTACHMENTS,
                    "PARTIAL_ATTACHMENTS"
                );
            }
            if (
                job_state.AreaSpecifications[key].ATTACHMENTS.AttachmentModifications &&
                job_state.AreaSpecifications[key].ATTACHMENTS.AttachmentModifications.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "AttachmentModifications",
                    key,
                    job_state.AreaSpecifications[key].ATTACHMENTS.AttachmentModifications
                );
            }
            if (job_state.AreaSpecifications[key].SKYLIGHTS && job_state.AreaSpecifications[key].SKYLIGHTS.length > 0) {
                ini_output += ConvertArrayToIniSection("Skylights", key, job_state.AreaSpecifications[key].SKYLIGHTS);
            }
            if (
                job_state.AreaSpecifications[key].BEAMMODIFICATIONS &&
                job_state.AreaSpecifications[key].BEAMMODIFICATIONS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "BeamModifications",
                    key,
                    job_state.AreaSpecifications[key].BEAMMODIFICATIONS
                );
            }
            if (
                job_state.AreaSpecifications[key].BEAMSPECMODIFICATIONS &&
                job_state.AreaSpecifications[key].BEAMSPECMODIFICATIONS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "BeamSpecModifications",
                    key,
                    job_state.AreaSpecifications[key].BEAMSPECMODIFICATIONS
                );
            }
            if (
                job_state.AreaSpecifications[key].BeamWallExtends &&
                job_state.AreaSpecifications[key].BeamWallExtends.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "BeamWallExtends",
                    key,
                    job_state.AreaSpecifications[key].BeamWallExtends
                );
            }
            if (
                job_state.AreaSpecifications[key].BEAMADJUSTMENTS &&
                job_state.AreaSpecifications[key].BEAMADJUSTMENTS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "BeamAdjustments",
                    key,
                    job_state.AreaSpecifications[key].BEAMADJUSTMENTS
                );
            }
            if (
                job_state.AreaSpecifications[key].POSTMODIFICATIONS &&
                job_state.AreaSpecifications[key].POSTMODIFICATIONS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "PostModifications",
                    key,
                    job_state.AreaSpecifications[key].POSTMODIFICATIONS
                );
            }
            if (
                job_state.AreaSpecifications[key].POSTADJUSTMENTS &&
                job_state.AreaSpecifications[key].POSTADJUSTMENTS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "PostAdjustments",
                    key,
                    job_state.AreaSpecifications[key].POSTADJUSTMENTS
                );
            }
            if (
                job_state.AreaSpecifications[key].PORTALPOSTS &&
                job_state.AreaSpecifications[key].PORTALPOSTS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "PortalPosts",
                    key,
                    job_state.AreaSpecifications[key].PORTALPOSTS
                );
            }
            if (
                job_state.AreaSpecifications[key].DECORATIONS &&
                job_state.AreaSpecifications[key].DECORATIONS.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "Decorations",
                    key,
                    job_state.AreaSpecifications[key].DECORATIONS
                );
            }
            if (job_state.AreaSpecifications[key].SHAPE.CUTOUTS) {
                ini_output += write_section_name_for_qq_nn("CUTOUTS", key);
                ini_output = convert_object_to_flat_ini(
                    ini_output,
                    job_state.AreaSpecifications[key].SHAPE.CUTOUTS,
                    hashMode
                );
            }
            if (job_state.AreaSpecifications[key].Footings && job_state.AreaSpecifications[key].Footings.length > 0) {
                ini_output += ConvertArrayToIniSection("Footings", key, job_state.AreaSpecifications[key].Footings);
            }
            if (
                job_state.AreaSpecifications[key].DrawingNotes &&
                job_state.AreaSpecifications[key].DrawingNotes.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "DrawingNotes",
                    key,
                    job_state.AreaSpecifications[key].DrawingNotes
                );
            }
            if (
                job_state.AreaSpecifications?.[key]?.NewBeams &&
                job_state.AreaSpecifications[key]?.NewBeams.length > 0
            ) {
                ini_output += ConvertArrayToIniSection("NewBeams", key, job_state.AreaSpecifications[key].NewBeams);
            }
            if (
                job_state.AreaSpecifications?.[key]?.NewPosts &&
                job_state.AreaSpecifications[key]?.NewPosts.length > 0
            ) {
                ini_output += ConvertArrayToIniSection("NewPosts", key, job_state.AreaSpecifications[key].NewPosts);
            }
            if (
                job_state.AreaSpecifications?.[key]?.CeilingFans &&
                job_state.AreaSpecifications[key]?.CeilingFans.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "CeilingFans",
                    key,
                    job_state.AreaSpecifications[key].CeilingFans
                );
            }
            if (
                job_state.AreaSpecifications?.[key]?.DrawingNotes &&
                job_state.AreaSpecifications[key]?.DrawingNotes.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "DrawingNotes",
                    key,
                    job_state.AreaSpecifications[key].DrawingNotes
                );
            }
            if (
                job_state.AreaSpecifications?.[key]?.SlatPanels &&
                job_state.AreaSpecifications[key]?.SlatPanels.length > 0
            ) {
                ini_output += ConvertArrayToIniSection("SlatPanels", key, job_state.AreaSpecifications[key].SlatPanels);
            }
            if (
                job_state.AreaSpecifications?.[key]?.LabelAdjustments &&
                job_state.AreaSpecifications[key]?.LabelAdjustments.length > 0
            ) {
                ini_output += ConvertArrayToIniSection(
                    "LabelAdjustments",
                    key,
                    job_state.AreaSpecifications[key].LabelAdjustments
                );
            }
        }
    }
    return ini_output;
}

function ConvertArrayToIniSection(section, areaIndex, array, header = null) {
    let ini_output = "";
    if (header !== "") ini_output += write_section_name_for_qq_nn(header ? header : section, areaIndex);
    ini_output += "Num" + section + "=" + array.length + "\n";

    let i = 1;
    for (var item of array) {
        for (var key in item) {
            ini_output += "_" + i + "_" + key + "=" + item[key] + "\n";
        }
        i++;
    }
    return ini_output;
}

function QQadjustments(in_job_state, config, brand = null) {
    if (!in_job_state.DesignParameters?.USE_ATTACHMENTS_2) return QQadjustmentsV1(in_job_state, config, brand);
    let job = deepCopy(in_job_state);

    if (job.AreaSpecifications) {
        for (let index in job.AreaSpecifications) {
            let areaIndex = Number(index);
            let this_area_data = job.AreaSpecifications[areaIndex];
            this_area_data.SHAPE.FrameDepth = this_area_data.SHAPE.Depth;
            this_area_data.SHAPE.FrameLength = this_area_data.SHAPE.Length;
        }
    }

    return job;
}

function QQadjustmentsV1(in_job_state, config, brand = null) {
    let job = deepCopy(in_job_state);

    if (job.DesignParameters?.DeckMode === 1) return job;

    let beam_types = config?.beam_types;

    let site = job?.SiteParameters;
    let ExistingStructure = site?.ExistingStructure;

    let attachment_Gutter_width = Number(site?.ExistingStructure.GutterWidth);

    if (job.AreaSpecifications) {
        for (let index in job.AreaSpecifications) {
            let areaIndex = Number(index);
            let this_area_data = job.AreaSpecifications[areaIndex];
            let next_area_data = job.AreaSpecifications[areaIndex + 1];
            let beam_and_post_data = this_area_data.BEAMS_AND_POSTS;

            let is_flat = false;
            let is_pitched = false;
            let is_portal = false;

            if (this_area_data.SHAPE.DesignType === DESIGN_TYPES.FLAT) is_flat = true;
            if (this_area_data.SHAPE.DesignType === DESIGN_TYPES.PITCHED) is_pitched = true;
            if (this_area_data.SHAPE.DesignType === DESIGN_TYPES.GABLE_PORTAL) is_portal = true;

            let current_gutter_width = 120;
            let this_gutter = this_area_data.GUTTERS_AND_DOWNPIPES.GutterType;
            if (config?.gutter_types && this_gutter && config?.gutter_types[this_gutter]) {
                current_gutter_width = Number(config?.gutter_types[this_gutter].width);
            }

            let attachment_BoxGutter_width = Number(this_area_data?.GUTTERS_AND_DOWNPIPES?.BoxGutterWidth);

            let fascia_beam_width = Number(beam_types?.[beam_and_post_data.BeamType1]?.width);
            if (!fascia_beam_width)
                fascia_beam_width =
                    window.LYSAGHT || job.Distributor?.Brand === "Lysaght" || brand === "Lysaght" ? 50 : 65;

            let back_attached = this_area_data?.ATTACHMENTS?.AttachmentTop === 1;
            let rear_paat = [];
            if (next_area_data && this_area_data?.SHAPE?.AREAJOIN?.JoinType === "Offset") {
                if (is_portal && this_area_data?.SHAPE?.RotateArea === 1) {
                    if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset < 0) {
                        if (
                            this_area_data?.ATTACHMENTS?.AttachmentLeft === 1 &&
                            next_area_data?.ATTACHMENTS?.AttachmentTop === 1
                        )
                            back_attached = true;
                        rear_paat = ["PAAT"];
                    }
                    if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset >= 0) back_attached = false;
                }
            }

            //

            QQajustmentsHandleBackAttached(
                back_attached,
                ExistingStructure,
                this_area_data,
                is_pitched,
                is_portal,
                rear_paat,
                site,
                fascia_beam_width,
                is_flat,
                attachment_BoxGutter_width,
                current_gutter_width,
                attachment_Gutter_width
            );

            QQajustmentsHandleFrontAttached(
                ExistingStructure,
                this_area_data,
                is_pitched,
                is_portal,
                site,
                fascia_beam_width,
                is_flat,
                attachment_BoxGutter_width,
                current_gutter_width,
                attachment_Gutter_width
            );

            let left_attached = this_area_data?.ATTACHMENTS?.AttachmentLeft === 1;

            QQajustmentsHandleLeftAttached(
                left_attached,
                ExistingStructure,
                this_area_data,
                is_pitched,
                is_portal,
                site,
                fascia_beam_width,
                is_flat,
                attachment_BoxGutter_width,
                current_gutter_width,
                attachment_Gutter_width
            );

            let right_attached = this_area_data?.ATTACHMENTS?.AttachmentRight === 1;
            let right_paat = [];
            if (next_area_data && this_area_data?.SHAPE?.AREAJOIN?.JoinType === "Offset") {
                if (is_portal) {
                    if (this_area_data?.SHAPE?.RotateArea === 0) {
                        if (
                            this_area_data?.ATTACHMENTS?.AttachmentTop === 1 &&
                            next_area_data?.ATTACHMENTS?.AttachmentTop === 1
                        )
                            right_attached = true;
                        if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset >= 0) right_attached = false;
                        if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset < 0) right_paat = ["PAAT"];
                    }
                } else if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset >= 0) right_attached = false;
            }

            QQajustmentsHandleRightAttached(
                right_attached,
                ExistingStructure,
                this_area_data,
                is_pitched,
                is_portal,
                site,
                fascia_beam_width,
                is_flat,
                attachment_BoxGutter_width,
                current_gutter_width,
                attachment_Gutter_width,
                right_paat
            );
        }

        for (let index in job.AreaSpecifications) {
            let areaIndex = Number(index);
            let last_area_data = job.AreaSpecifications[areaIndex - 1];
            let this_area_data = job.AreaSpecifications[areaIndex];
            let next_area_data = job.AreaSpecifications[areaIndex + 1];
            let beam_and_post_data = this_area_data.BEAMS_AND_POSTS;

            let is_flat = false;
            let is_pitched = false;
            let is_portal = false;

            let fascia_beam_width = Number(beam_types?.[beam_and_post_data.BeamType1]?.width);
            if (!fascia_beam_width)
                fascia_beam_width =
                    window.LYSAGHT || job.Distributor?.Brand === "Lysaght" || brand === "Lysaght" ? 50 : 65;

            if (this_area_data.SHAPE.DesignType === DESIGN_TYPES.FLAT) is_flat = true;
            if (this_area_data.SHAPE.DesignType === DESIGN_TYPES.PITCHED) is_pitched = true;
            if (this_area_data.SHAPE.DesignType === DESIGN_TYPES.GABLE_PORTAL) is_portal = true;

            if (is_flat || is_portal) {
                if (
                    is_flat &&
                    next_area_data &&
                    this_area_data?.SHAPE?.AREAJOIN?.JoinType === "L2" &&
                    next_area_data.SHAPE.DesignType === DESIGN_TYPES.GABLE_PORTAL
                ) {
                    if (next_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB === 2) {
                        let attachment_BoxGutter_width = Number(next_area_data?.GUTTERS_AND_DOWNPIPES?.BoxGutterWidth);

                        this_area_data.SHAPE.Length -= attachment_BoxGutter_width;
                    } else if (next_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB === 1) {
                        this_area_data.SHAPE.Length -= attachment_Gutter_width;

                        let current_gutter_width = 120;
                        let this_gutter = next_area_data.GUTTERS_AND_DOWNPIPES.GutterType;
                        if (config?.gutter_types && this_gutter && config?.gutter_types[this_gutter]) {
                            current_gutter_width = config?.gutter_types[this_gutter].width;
                        }

                        if (current_gutter_width) this_area_data.SHAPE.Length -= current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length -= attachment_Gutter_width;
                    }

                    this_area_data.SHAPE.Length -= next_area_data.SHAPE.DesignType === DESIGN_TYPES.GABLE_PORTAL;
                }
                if (next_area_data && this_area_data?.SHAPE?.AREAJOIN?.JoinType === "L1") {
                    this_area_data.SHAPE.Length -= next_area_data.SHAPE.Depth;
                }
                if (last_area_data && last_area_data?.SHAPE?.AREAJOIN?.JoinType === "L2") {
                    this_area_data.SHAPE.Length -= last_area_data.SHAPE.Depth;

                    if (is_portal) {
                        this_area_data.SHAPE.Length -= fascia_beam_width;
                    }
                }

                if (
                    next_area_data &&
                    this_area_data?.SHAPE?.AREAJOIN?.JoinType === "Angle" &&
                    this_area_data?.SHAPE?.AREAJOIN?.JoinAngle > 0
                ) {
                    let ext_results = find_join_angle_extension(
                        this_area_data?.SHAPE?.AREAJOIN?.JoinAngle,
                        this_area_data.SHAPE.Depth,
                        next_area_data.SHAPE.Depth
                    );

                    if (ext_results) {
                        this_area_data.SHAPE.Length -= ext_results.ext_this;
                        next_area_data.SHAPE.Length -= ext_results.ext_next;
                    }
                }
            }
        }
    }

    return job;
}

// Copy of Common.js If changes occur please update here too.
function deepCopy(obj) {
    var rv;

    switch (typeof obj) {
        case "object":
            if (obj === null) {
                // null => null
                rv = null;
            } else {
                switch (toString.call(obj)) {
                    case "[object Array]":
                        // It's an array, create a new array with
                        // deep copies of the entries
                        rv = obj?.map(deepCopy);
                        break;
                    case "[object Date]":
                        // Clone the date
                        rv = new Date(obj);
                        break;
                    case "[object RegExp]":
                        // Clone the RegExp
                        rv = new RegExp(obj);
                        break;
                    case "[object Function]":
                        // Clone the Function
                        rv = CloneFunction(obj);
                        break;
                    // ...probably a few others
                    default:
                        // Some other kind of object, deep-copy its
                        // properties into a new object
                        rv = Object.keys(obj).reduce(function (prev, key) {
                            prev[key] = deepCopy(obj[key]);
                            return prev;
                        }, {});
                        break;
                }
            }
            break;
        default:
            // It's a primitive, copy via assignment
            rv = obj;
            break;
    }
    return rv;
}

const DESIGN_TYPES = {
    // matched to VQU
    FLAT: "Flat Roof",
    GALV_FLAT: "Galv Flat Roof",
    PITCHED: "Pitched Roof",
    GABLE_PORTAL: "Gable Hip Roof",
    DECK: "Flat Deck",
};

function CloneFunction() {
    var that = this;
    var temp = function temporary() {
        return that.apply(this, arguments);
    };
    for (var key in this) {
        if (this.hasOwnProperty(key)) {
            temp[key] = this[key];
        }
    }
    return temp;
}

export function find_join_angle_extension(JoinAngle, this_Depth, next_Depth) {
    let ext_this = 0;
    let ext_next = 0;

    let alpha_r = 0;
    let omicron_r = 0;
    let beta_r = 0;
    let gamma_r = 0;
    let a = 0;
    let d = 0;
    let x_r = 0;
    let y_r = 0;
    let f = 0;
    let rad_90 = 90.0 * (Math.PI / 180);

    if (Math.abs(JoinAngle) < 0.000001) {
        ext_this = 0;
        ext_next = 0;
        return {
            ext_this: ext_this,
            ext_next: ext_next,
        };
    }

    alpha_r = JoinAngle * (Math.PI / 180);
    omicron_r = rad_90;
    beta_r = rad_90;
    gamma_r = 2 * rad_90 - alpha_r;

    a = this_Depth;
    d = next_Depth;

    x_r = rad_90 - alpha_r / 2;
    y_r = Math.atan(((a - d) / (a + d)) * (1 / Math.tan(alpha_r / 2)));
    f = a * Math.cos(x_r - y_r) + d * Math.cos(x_r + y_r);

    ext_this = (f * Math.sin(omicron_r - x_r - y_r)) / Math.sin(gamma_r);
    ext_next = (f * Math.sin(beta_r - x_r + y_r)) / Math.sin(gamma_r);

    return {
        ext_this: Math.round(ext_this),
        ext_next: Math.round(ext_next),
    };
}

function QQajustmentsHandleBackAttached(
    back_attached,
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    rear_paat,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width
) {
    if (back_attached) {
        let rear_attachment = ExistingStructure?.AttachmentType;
        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name ? obj?.Name?.includes("Back") : false;
            });
            if (items.length > 0 && items[0]?.FasciaType) rear_attachment = items[0]?.FasciaType;
        }

        if (rear_attachment.includes("Fascia") && (is_pitched || is_portal)) rear_attachment = "Beam";

        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS && rear_paat.length === 0) {
            rear_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Back");
            });
        }

        if (rear_attachment.includes("Flyover")) {
            this_area_data.SHAPE.Depth -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            rear_paat.length > 0 &&
            (rear_attachment.includes("Fascia") || rear_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Depth -= fascia_beam_width;
        } else if (rear_attachment.includes("Beam") || rear_attachment.includes("Riser")) {
            if (is_portal) {
                //
                if (rear_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 2) {
                    this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 1) {
                    this_area_data.SHAPE.Depth += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Depth += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Depth += attachment_Gutter_width;
            }
        }
    } else {
        if (is_flat) {
            if (this_area_data.SHAPE.SheetDirection === "Front" || this_area_data.SHAPE.SheetDirection === "Back") {
                if (this_area_data.SHAPE?.OH_Back > 0) {
                    this_area_data.SHAPE.Depth += Number(this_area_data.SHAPE?.OH_Back);
                }
            }
        }
    }
}

function QQajustmentsHandleFrontAttached(
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width
) {
    if (this_area_data?.ATTACHMENTS?.AttachmentBottom === 1 && fascia_beam_width) {
        let front_attachment = ExistingStructure?.AttachmentType;

        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name?.includes("Front");
            });
            if (items.length > 0 && items[0]?.FasciaType) front_attachment = items[0]?.FasciaType;
        }
        if (front_attachment.includes("Fascia") && (is_pitched || is_portal)) front_attachment = "Beam";

        let front_paat = [];
        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS) {
            front_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Front");
            });
        }

        if (front_attachment.includes("Flyover")) {
            this_area_data.SHAPE.Depth -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            front_paat.length > 0 &&
            (front_attachment.includes("Fascia") || front_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Depth -= fascia_beam_width;
        } else if (front_attachment.includes("Beam") || front_attachment.includes("Riser")) {
            if (is_portal) {
                if (front_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterF === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterF === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 2) {
                    this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 1) {
                    this_area_data.SHAPE.Depth += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Depth += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Depth += attachment_Gutter_width;
            }
        }
    } else {
        if (is_flat) {
            if (this_area_data.SHAPE.SheetDirection === "Front" || this_area_data.SHAPE.SheetDirection === "Back") {
                if (this_area_data.SHAPE?.OH_Front > 0) {
                    this_area_data.SHAPE.Depth += Number(this_area_data.SHAPE?.OH_Front);
                }
            }
        }
    }
}

function QQajustmentsHandleLeftAttached(
    left_attached,
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width
) {
    if (left_attached && fascia_beam_width) {
        let left_attachment = ExistingStructure?.AttachmentType;

        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name?.includes("Left");
            });
            if (items.length > 0 && items[0]?.FasciaType) left_attachment = items[0]?.FasciaType;
        }
        if (left_attachment.includes("Fascia") && (is_pitched || is_portal)) left_attachment = "Beam";

        let left_paat = [];
        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS) {
            left_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Left");
            });
        }

        if (left_attachment.includes("Flyover") || ExistingStructure?.AttachmentType === "Flyover") {
            this_area_data.SHAPE.Length -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            left_paat.length > 0 &&
            (left_attachment.includes("Fascia") || left_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Length -= fascia_beam_width;
        } else if (left_attachment.includes("Beam") || left_attachment.includes("Riser")) {
            if (is_portal) {
                if (left_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterL === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterL === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 2) {
                    this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 1) {
                    this_area_data.SHAPE.Length += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Length += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Length += attachment_Gutter_width;
            }
        }
    }
}

function QQajustmentsHandleRightAttached(
    right_attached,
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width,
    right_paat
) {
    if (right_attached && fascia_beam_width) {
        let right_attachment = ExistingStructure?.AttachmentType;

        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name?.includes("Right");
            });
            if (items.length > 0 && items[0]?.FasciaType) right_attachment = items[0]?.FasciaType;
        }
        if (right_attachment.includes("Fascia") && (is_pitched || is_portal)) right_attachment = "Beam";

        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS && right_paat.length === 0) {
            right_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Right");
            });
        }

        if (right_attachment.includes("Flyover") || ExistingStructure?.AttachmentType === "Flyover") {
            this_area_data.SHAPE.Length -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            right_paat.length > 0 &&
            (right_attachment.includes("Fascia") || right_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Length -= fascia_beam_width;
        } else if (right_attachment.includes("Beam") || right_attachment.includes("Riser")) {
            if (is_portal) {
                if (right_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterR === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterR === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 2) {
                    this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 1) {
                    this_area_data.SHAPE.Length += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Length += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Length += attachment_Gutter_width;
            }
        }
    }
}
